import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['auditorSelect', 'visibilityToggleable']

  declare readonly visibilityToggleableTargets: HTMLElement[]
  declare readonly auditorSelectTarget: HTMLSelectElement

  connect (): void {
    if (this.auditorSelectTarget !== null && this.auditorSelectTarget.value !== '') {
      this.show()
    }
  }

  show (event?: Event): void {
    const condition = this.auditorSelectTarget === null || this.auditorSelectTarget.value === ''

    this.visibilityToggleableTargets.forEach(target => {
      target.classList.toggle('hidden', condition)
    })
  }
}
